/* eslint-disable @typescript-eslint/consistent-type-definitions */
import * as React from 'react';
const RangeContext = React.createContext({});
export default RangeContext;
